var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeNightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 16,
    r: 14,
    fill: "#8B8B8B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5447_25633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 22.7637C15.6425 22.7637 15.3536 23.0525 15.3536 23.409V25.3572C15.3536 25.7137 15.6425 26.0025 15.9989 26.0025C16.3554 26.0025 16.6443 25.7137 16.6443 25.3572V23.409C16.6443 23.0525 16.3554 22.7637 15.9989 22.7637Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 9.24054C16.3554 9.24054 16.6443 8.9517 16.6443 8.59523V6.64726C16.6443 6.29079 16.3554 6.00195 15.9989 6.00195C15.6425 6.00195 15.3536 6.29079 15.3536 6.64726V8.59532C15.3536 8.9517 15.6425 9.24054 15.9989 9.24054Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3067 20.7827L8.92864 22.16C8.67654 22.4121 8.67646 22.8206 8.92838 23.0726C9.05443 23.1987 9.21963 23.2617 9.38483 23.2617C9.54994 23.2617 9.71506 23.1988 9.84102 23.0729L11.2191 21.6955C11.4712 21.4435 11.4712 21.035 11.2193 20.783C10.9672 20.5308 10.5586 20.5307 10.3067 20.7827Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2364 11.4102C21.4015 11.4102 21.5666 11.3473 21.6925 11.2213L23.0705 9.84394C23.3226 9.59193 23.3227 9.18341 23.0708 8.93139C22.8187 8.67912 22.41 8.67921 22.1581 8.93113L20.7801 10.3085C20.528 10.5605 20.5279 10.969 20.7798 11.2211C20.906 11.3472 21.0712 11.4102 21.2364 11.4102Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23902 16.0008C9.23902 15.6443 8.95018 15.3555 8.59371 15.3555H6.64531C6.28884 15.3555 6 15.6443 6 16.0008C6 16.3572 6.28884 16.6461 6.64531 16.6461H8.59371C8.95009 16.6461 9.23902 16.3572 9.23902 16.0008Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3547 15.3555H23.4057C23.0492 15.3555 22.7604 15.6443 22.7604 16.0008C22.7604 16.3572 23.0492 16.6461 23.4057 16.6461H25.3547C25.7112 16.6461 26 16.3572 26 16.0008C26 15.6443 25.7112 15.3555 25.3547 15.3555Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3065 11.2211C10.4325 11.3471 10.5977 11.4101 10.7629 11.4101C10.928 11.4101 11.0932 11.3471 11.2191 11.2211C11.4712 10.9691 11.4712 10.5605 11.2192 10.3086L9.84187 8.93124C9.58977 8.67914 9.18116 8.67923 8.92932 8.93116C8.67722 9.18317 8.67722 9.59178 8.92923 9.84371L10.3065 11.2211Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6936 20.7828C21.4415 20.5308 21.0328 20.5307 20.781 20.7827C20.5289 21.0347 20.5289 21.4433 20.7809 21.6954L22.1582 23.0727C22.2842 23.1988 22.4493 23.2617 22.6145 23.2617C22.7797 23.2617 22.9449 23.1988 23.0708 23.0728C23.3229 22.8208 23.3229 22.4122 23.0709 22.1601L21.6936 20.7828Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 10.1914C12.7962 10.1914 10.1899 12.7977 10.1899 16.0012C10.1899 19.2046 12.7962 21.8109 15.9997 21.8109C19.2032 21.8109 21.8094 19.2046 21.8094 16.0012C21.8094 12.7977 19.2032 10.1914 15.9997 10.1914ZM15.9997 20.5204C13.5078 20.5204 11.4806 18.4932 11.4806 16.0012C11.4806 13.5093 13.5078 11.482 15.9997 11.482C18.4915 11.482 20.5187 13.5093 20.5187 16.0012C20.5187 18.493 18.4915 20.5204 15.9997 20.5204Z",
    fill: "#8B8B8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5447_25633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeNightIcon);
export default __webpack_public_path__ + "static/media/mode-night-icon.6da00d8a948f42c7df83cc5a1c1bf0b3.svg";
export { ForwardRef as ReactComponent };